// @flow
import { useParams } from 'react-router-dom';
import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';
import { useGetSPTableFlowWorkloadViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';

export const SPTableFlowWorkloadContext = createContext({});

export const SPTableFlowWorkloadContextProvider = ({ children }) => {
  const params = useParams();

  return (
    <DataFetcherContainer
      dataFetchingArgs={useMemo(
        () => [
          { ...params },
          {
            skip: shouldSkipDataFetching(params),
          },
        ],
        [params]
      )}
      dataFetchingFunction={useCallback(useGetSPTableFlowWorkloadViewQuery, [])}
    >
      {(data) => {
        return (
          <SPTableFlowWorkloadContext.Provider value={data}>
            {children}
          </SPTableFlowWorkloadContext.Provider>
        );
      }}
    </DataFetcherContainer>
  );
};

export const useSPTableFlowContext = () => useContext(SPTableFlowWorkloadContext);
